module.exports = __webpack_public_path__ + "img/ELASTICSEARCH_LOGO.2ed29fc7.png";